import React, { useState } from "react";
import { Switch } from "@headlessui/react";
import axios from "axios";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
export default function UserToggle({ item }) {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
  };
  const [enabled, setEnabled] = useState(item.type === 1 ? true : false);
  const Handler_Toggle = (id, e) => {
    setEnabled(!enabled);
    let status = e ? 1 : 0;
    const data = {
      type: status,
    };
    console.log(data);
    axios
      .put(`http://192.168.1.84:4001/api/userstatus/${id}`, data, {
        headers: headers,
      })
      .then((res) => {
        NotificationManager.success(res.data.message);
      })
      .catch((err) => {
        NotificationManager.error(err.response.data.message);
      });
  };
  return (
    <>
      <NotificationContainer />
      <Switch.Group>
        <div className="flex items-center justify-center">
          <Switch.Label className="mr-4">
            {item.type == 1 ? (
              <span className="text-green-800 text-xl ml-5 w-64  inline-block">
                مدیر
              </span>
            ) : (
              <span className="text-red-800 text-xl ml-5 w-64  inline-block">
                کاربر عادی
              </span>
            )}
          </Switch.Label>
          {/* <Switch
            checked={item.type==1?enabled:null}
            onChange={(e) => Handler_Toggle(item.id, e)}
            className={`${
              enabled ? "bg-blue-600" : "bg-gray-200"
            } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
          >
            <span
              className={`${
                enabled ? "-translate-x-6" : "-translate-x-1"
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch> */}
        </div>
      </Switch.Group>
    </>
  );
}
